import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Toolbar from './components/Toolbar';
import Projects from './components/Projects';
import Work from './components/Work';
import Description from './components/Description';

import Terminal from './components/Terminal';
import NotFound from './components/NotFound';

const Home = () => (
  <div>
    <Description />
    <Projects />
    <Work />
    <Terminal />
  </div>
);

const MainLayout = ({ children }) => (
  <div className="flex flex-col md:flex-row">
    <NavBar />
    <div className="flex-grow md:ml-64 pt-20 max-w-none">
      <Toolbar />
      {children}
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <MainLayout>
            <Home />
          </MainLayout>
        } />
        <Route path="/about" element={
          <MainLayout>
            <Description />
          </MainLayout>
        } />
        <Route path="/projects" element={
          <MainLayout>
            <Projects />
          </MainLayout>
        } />
        <Route path="/work" element={
          <MainLayout>
            <Work />
          </MainLayout>
        } />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
